<template>
<div>
    Redirecting...
</div>
</template>
 
<script>
export default {
  name: 'Home',
};
</script>